import PropTypes from "prop-types"
import React from "react"
import styled from "styled-components"

// ----------------------------------------------------------------------------

function AppHeading(props) {
    // -------------------------------------
    // Props destructuring
    // -------------------------------------

    // -------------------------------------
    // Hooks (e.g. useState, useMemo ...)
    // -------------------------------------

    // -------------------------------------
    // Effects
    // -------------------------------------

    // -------------------------------------
    // Component functions
    // -------------------------------------

    function getStyle() {
        switch (props.boldness) {
            case "medium":
                return "medium"
            case "bold":
                return "bold"
            default:
                return "medium"
        }
    }

    // -------------------------------------
    // Component local variables
    // -------------------------------------

    return (
        <h2 className={`${props.className} ${getStyle()}`}>{props.children}</h2>
    )
}

// ----------------------------------------------------------------------------
// Component PropTypes and default props
// ----------------------------------------------------------------------------

AppHeading.propTypes = {
    className: PropTypes.string.isRequired,
    boldness: PropTypes.oneOf(["bold", "medium"]),
    children: PropTypes.any,
}

AppHeading.defaultProps = {}

// ----------------------------------------------------------------------------

const StyledAppHeading = styled(AppHeading)`
    & {
        &.medium {
            font-size: 16px;
            line-height: 110%;
            font-family: "Poppins-Bold";
        }
        &.bold {
            font-family: "Poppins-Bold";
            font-size: 20px;
            line-height: 110%;
            letter-spacing: 0.01em;
        }
    }
`
// ----------------------------------------------------------------------------

export default StyledAppHeading
